import { useEffect, useState } from "react";
import { deleteIcon, editIconInBox } from "../../../assets";
import WrapperCard from "../../../component-lib/Atoms/card/EventEHRWrapperCard";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import Table from "../../../component-lib/Organisms/table/EventEHRTable";
import useDeviceType from "../../../custom-hooks/DeviceType";
import DischargeFormPreviewModel from "../../../utils/discharge-form-preview-model/DischargeFormPreviewModel";
import EventEHRPatientProfileDetailCard from "../../../component-lib/Organisms/patient-profile-detail-card/EventEHRPatientProfileDetailCard";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import EventEHRCareVisitFlowButtons from "../../../component-lib/Molecules/care-visit-flow-buttons/EventEHRCareVisitFlowButtons";
import EventEHREditChiefComplaintDialog from "./dialogs/edit-chief-complaint-dialog/EventEHREditChiefComplaintDialog";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  getVisitNoteById,
  patchVisitNoteData,
  postVisitNoteData,
} from "../patientSaga";
import {
  componentKey,
  setCloseChiefComplaintDialog,
  setDataToDischargeForm,
} from "../patientSlice";
import { getPatientDetailsDataFunction } from "../constants";
import { eventEHRCustomToastMessage } from "../../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import DiagnosisCodeSelect from "./DiagnosisCodeSelect";

const SelfCareVisitFlow = () => {
  const {
    visitNoteCareFlowData,
    closeChiefComplaintDialog,
    updateVisitNoteDataOnceDraftNote,
  } = useSelector((state: any) => state[componentKey]);

  const { patientId, visitNoteId } = useParams();
  const navigate = useNavigate();
  const patientDetailsData = visitNoteCareFlowData;
  const dispatch = useDispatch();
  const deviceType = useDeviceType();
  const [openDischargeForm, setOpenDischargeForm] = useState(false);
  const [openChiefComplaintDialog, setOpenChiefComplaintDialog] =
    useState(false);

  const patientDetails = getPatientDetailsDataFunction(patientDetailsData);

  const [selectedDiagnosis, setSelectedDiagnosis] = useState<any>([]);

  const ICDCodeColumns = [
    {
      field: "srNo",
      label: <div>Sr No</div>,
      renderLogic: (row: any, index: any) => {
        return <p className="text-neutral-90 font-normal">{index + 1}</p>;
      },
    },
    {
      field: "code",
      label: <div>Code</div>,
      renderLogic: (row: any) => {
        return <p className="text-primary-main font-normal">{row?.label}</p>;
      },
    },
    {
      field: "details",
      label: <div className="w-[70vw]">Details</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.description}</p>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              <img
                alt="delete-icon"
                className="cursor-pointer"
                src={deleteIcon}
                width={"18px"}
                height={"19.5px"}
                onClick={() => {
                  // Delete Particular Item
                  setSelectedDiagnosis((prevItems: any) =>
                    prevItems?.filter((item: any) => item?.id !== row?.id)
                  );
                }}
              />
            </div>
          </>
        );
      },
    },
  ];

  // UPDATE DRAFT DATA IF EXISTS
  useEffect(() => {
    setSelectedDiagnosis(
      selectedDiagnosis?.length
        ? selectedDiagnosis.map((data: any, index: number) => ({
            id: data?.code,
            index,
            label: data?.label,
            value: data?.value,
            description: data?.description,
          }))
        : visitNoteCareFlowData?.visit_note?.[0]?.assessment?.map(
            (data: any, index: number) => ({
              id: data?.code,
              index,
              label: data?.code,
              value: data?.code,
              description: data?.desc,
            })
          ) || []
    );
  }, [visitNoteCareFlowData]);

  // ONCE CHIEF COMPLAINT DIALOG CLOSE REFRESH DATA
  useEffect(() => {
    if (closeChiefComplaintDialog) {
      setOpenChiefComplaintDialog(false);
      dispatch(setCloseChiefComplaintDialog(false));
    }
    const payload = {
      id: visitNoteId,
      comesFrom: "selfCare",
    };
    dispatch(getVisitNoteById(payload));
  }, [closeChiefComplaintDialog, updateVisitNoteDataOnceDraftNote]);



  const handleDraftButtonClick = () => {
    // CHECK IF ICD 10 CODE SELECTED OR NOT IF NOT THEN RETURN FROM  FUNCTION
    if (!selectedDiagnosis || selectedDiagnosis?.length === 0) {
      eventEHRCustomToastMessage({
        title: `Please select at least one ICD-10 code.`,
        status: "error",
      });
      return;
    }
    try {
      if (visitNoteCareFlowData?.visit_note.length === 0) {
        const payload = {
          apiPayload: {
            patientId: patientId,
            visitId: visitNoteId,
            assessment: selectedDiagnosis?.map((data: any) => ({
              code: data?.label,
              desc: data?.description,
            })),
            status: "Draft",
          },
          comesFrom: "selfCareVisitNoteSaveAsDraft",
          navigate,
          onSuccess: () => navigate(`/patient/${patientId}?tab=visits`),
        };
        dispatch(postVisitNoteData(payload));
      } else {
        const payload = {
          apiPayload: {
            assessment: selectedDiagnosis?.map((data: any) => ({
              code: data?.label,
              desc: data?.description,
            })),
            status: "Draft",
          },
          comesFrom: "selfCareVisitNoteSaveAsDraft",
          visitNoteId: visitNoteCareFlowData?.visit_note?.[0]?.id,
          navigate,
          onSuccess: () => navigate(`/patient/${patientId}?tab=visits`),
        };
        dispatch(patchVisitNoteData(payload));
      }
    } catch (error) {
      console.log("error:", error);
    }
  };

  //  HANDLE PROCEED TO DISCHARGE BUTTON CLICK EVENT
  const handleProceedToDischargeButtonClick = () => {
    // CHECK IF ICD 10 CODE SELECTED OR NOT IF NOT THEN RETURN FROM  FUNCTION
    if (!selectedDiagnosis || selectedDiagnosis?.length === 0) {
      eventEHRCustomToastMessage({
        title: `Please select at least one ICD-10 code.`,
        status: "error",
      });
      return;
    }
    dispatch(
      setDataToDischargeForm({
        ...visitNoteCareFlowData,
        assessment: selectedDiagnosis,
      })
    );
    setOpenDischargeForm(true);
  };

  return (
    <WrapperCard
      customClasses="m-3 p-3 pl-4 pr-4 flex-1 min-h-0 overflow-auto"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <div className="flex flex-col justify-between gap-3 h-full">
        <div className="flex flex-col justify-between gap-3 overflow-hidden">
          <Heading title="Visit Note" customStyle={{ color: "#1D1D1D" }} />

          {/* MAIN CONTENT */}
          <div className="pr-2 overflow-auto">
            <div className="flex background-color-F1F1F1 border-radius-8px py-4 px-6">
              <EventEHRPatientProfileDetailCard
                patientDetails={patientDetails}
              />
            </div>
            <div className="mt-5 flex flex-col">
              <div className="flex justify-between items-center mb-2">
                <Heading
                  title="Chief Complaint"
                  customStyle={{ fontSize: "16px" }}
                />
                <img
                  alt="edit-icon"
                  src={editIconInBox}
                  width={"36px"}
                  height={"36px"}
                  className="cursor-pointer"
                  onClick={() => {
                    setOpenChiefComplaintDialog(true);
                  }}
                />
              </div>
              <div>
                <div
                  className="font-weight-500 border-radius-8px color-979797"
                  style={{
                    padding: "14px 16px",
                    border: "1px solid #D2D2D2",
                    background: "#F8F8F8",
                  }}
                >
                  {visitNoteCareFlowData?.chiefComplaints}
                </div>
              </div>
              <div className="mt-4">
                <Heading title="Diagnosis" customStyle={{ fontSize: "16px" }} />
                <div className="mt-6">
                  <DiagnosisCodeSelect
                    setSelectedDiagnosis={setSelectedDiagnosis}
                  />
                </div>
              </div>

              <div className="overflow-auto mb-2 mt-6 min-h-[350px] max-h-[350px]">
                <Table
                  columns={ICDCodeColumns}
                  rows={selectedDiagnosis}
                  noDataFoundMessage={"No ICD 10 Code entered"}
                />
              </div>
            </div>
          </div>
        </div>
        {/* FOOTER BUTTONS */}
        <EventEHRCareVisitFlowButtons
          isTransferButtonPresent={false}
          handleCancelButtonClickEvent={() => {
            navigate(`/patient/${patientId}?tab=visits`);
          }}
          handleSaveAsDraftButtonClickEvent={() => {
            handleDraftButtonClick();
          }}
          handleTransferButtonClickEvent={() => {}}
          handleProceedToDischargeButtonClickEvent={() => {
            handleProceedToDischargeButtonClick();
          }}
        />
      </div>
      {openDischargeForm && (
        <DischargeFormPreviewModel
          patientId={patientId}
          visitNoteId={visitNoteId}
          open={openDischargeForm}
          handleCloseModel={() => setOpenDischargeForm(false)}
        />
      )}
      {/* EDIT CHIEF COMPLAINT DIALOG */}
      {openChiefComplaintDialog && (
        <EventEHREditChiefComplaintDialog
          defaultSelectedData={visitNoteCareFlowData?.chiefComplaints}
          dialogHeading="Edit Chief Complaint"
          isOpen={openChiefComplaintDialog}
          handleClose={() => {
            setOpenChiefComplaintDialog(false);
          }}
        />
      )}
    </WrapperCard>
  );
};

export default SelfCareVisitFlow;
